import { render, staticRenderFns } from "./promo_menu.vue.js?vue&type=template&id=7ee639bb&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./promo_menu.vue?vue&type=template&id=7ee639bb&vue3"
import script from "./promo_menu.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./promo_menu.vue?vue&type=script&lang=js&vue3"
export * from "./promo_menu.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./promo_menu.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports